import { Box, useTheme } from '@mui/material';
import { Plus } from '@phosphor-icons/react';
import React from 'react';
import { useDarkMode } from '../../../../hooks/useDarkMode';

interface SidebarAddButtonProps {
  onClick: (event: React.MouseEvent) => void;
}

export const SidebarAddButton: React.FC<SidebarAddButtonProps> = ({
  onClick,
}) => {
  const theme = useTheme();
  const palette = theme.customColorPalette;
  const isDarkMode = useDarkMode();
  const iconColor = isDarkMode ? palette.gray[400] : palette.gray[500];

  return (
    <Box
      component='button'
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onClick(e);
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        color: iconColor,
        '&:hover': {
          backgroundColor: isDarkMode ? palette.gray[800] : palette.gray[200],
        },
      }}
    >
      <Plus size={16} color={iconColor} />
    </Box>
  );
};
